import { MELEE } from "@eldrun/content";

/**
 * Cadência da ação principal no cliente, espelhando a porta do servidor: um clique feito até
 * 0,15 s antes do fim do ciclo fica guardado e sai quando a porta abre (não se perde); segurar
 * repete a cada ciclo.
 */
export class ActionGate {
  private nextAt = 0;
  private buffered = false;
  private readonly bufferMs: number;

  constructor(bufferSeconds: number = MELEE.buffer) {
    this.bufferMs = bufferSeconds * 1000;
  }

  /** A ação deve sair agora? */
  poll(now: number, clicked: boolean, held: boolean): boolean {
    if (clicked && now < this.nextAt && now >= this.nextAt - this.bufferMs) this.buffered = true;
    if (!(clicked || held || this.buffered) || now < this.nextAt) return false;
    this.buffered = false;
    return true;
  }

  /** A ação saiu: a próxima só depois de `seconds`. */
  start(now: number, seconds: number): void {
    this.nextAt = now + seconds * 1000;
  }

  /** Painel aberto, caído ou comendo: nada fica guardado. */
  cancel(): void {
    this.buffered = false;
  }
}
